import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ENTITY_TYPES_CONFIG, _wp, _PRODUCT_TYPES_CONFIG;

import { ENTITY_TYPES, PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
export { ENTITY_TYPES, PRODUCT_TYPES };
/**
 * Marketplace entity types in order from lowest to highest level of nesting.
 *
 * @type {Array<String>}
 */

export var ENTITY_TYPES_ORDERING = [ENTITY_TYPES.OFFERS, ENTITY_TYPES.PRODUCTS, ENTITY_TYPES.INSTITUTIONS];
/**
 * Marketplace entity types config.
 *
 * @type {Object}
 */

export var ENTITY_TYPES_CONFIG = (_ENTITY_TYPES_CONFIG = {}, _defineProperty(_ENTITY_TYPES_CONFIG, ENTITY_TYPES.OFFERS, {
  namespace: 'offers',
  singular: 'offer'
}), _defineProperty(_ENTITY_TYPES_CONFIG, ENTITY_TYPES.PRODUCTS, {
  namespace: 'products',
  singular: 'product'
}), _defineProperty(_ENTITY_TYPES_CONFIG, ENTITY_TYPES.INSTITUTIONS, {
  namespace: 'institutions',
  singular: 'institution',
  supportedProductTypes: [PRODUCT_TYPES.AUTO_LOANS, PRODUCT_TYPES.BANKING, PRODUCT_TYPES.CREDIT_CARDS, PRODUCT_TYPES.EDUCATION_LOANS, PRODUCT_TYPES.INSURANCE, PRODUCT_TYPES.INVESTING, PRODUCT_TYPES.PERSONAL_LOANS, PRODUCT_TYPES.SOFTWARE]
}), _ENTITY_TYPES_CONFIG);
/**
 * Marketplace product types config.
 *
 * @type {Object}
 */

export var PRODUCT_TYPES_CONFIG = (_PRODUCT_TYPES_CONFIG = {}, _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.AUTO_LOANS, {
  marketplace: {
    endpoint: 'auto_loans'
  }
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.BANKING, {
  marketplace: {
    endpoint: 'banking'
  },
  wp: (_wp = {}, _defineProperty(_wp, ENTITY_TYPES.PRODUCTS, {
    endpoint: 'banking-products'
  }), _defineProperty(_wp, ENTITY_TYPES.INSTITUTIONS, {
    endpoint: 'banking-institutions'
  }), _wp)
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.CREDIT_CARDS, {
  marketplace: {
    endpoint: 'credit_cards'
  },
  wp: _defineProperty({}, ENTITY_TYPES.OFFERS, {
    endpoint: 'credit-card-offers'
  })
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.EDUCATION_LOANS, {
  marketplace: {
    endpoint: 'education_loans'
  }
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.FTHB_PROGRAMS, {
  marketplace: {
    endpoint: 'first_time_home_buyer_programs'
  }
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.INSURANCE, {
  marketplace: {
    endpoint: 'insurance'
  }
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.INVESTING, {
  marketplace: {
    endpoint: 'investing'
  },
  wp: _defineProperty({}, ENTITY_TYPES.OFFERS, {
    endpoint: 'investing-offers'
  })
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.MORTGAGES, {
  marketplace: {
    endpoint: 'mortgages'
  },
  wp: _defineProperty({}, ENTITY_TYPES.PRODUCTS, {
    endpoint: 'lenders'
  })
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.PERSONAL_LOANS, {
  marketplace: {
    endpoint: 'personal_loans'
  }
}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.SMB_LOANS, {
  marketplace: {
    endpoint: 'small_medium_business_loans'
  } // omission of corresponding wp, entity-type endpoint as there is no need for `additional_data`

}), _defineProperty(_PRODUCT_TYPES_CONFIG, PRODUCT_TYPES.SOFTWARE, {
  marketplace: {
    endpoint: 'software'
  } // omission of corresponding wp, entity-type endpoint as there is no need for `additional_data`

}), _PRODUCT_TYPES_CONFIG);
/**
 * Top level WP props to include alongside the `{post_type}_data` blob.
 *
 * @type {Array}
 */

export var WP_ENTITY_PROPS_WHITELIST = ['author', 'date', 'date_gmt', 'id', 'modified', 'modified_gmt', 'slug', 'title'];